<template>
  <div class="headerssss">
    <!-- Header Start -->
    <header>
      <!-- container start -->
      <div class="container">
        <!-- navigation bar -->
        <nav class="navbar navbar-expand-lg">          
            <router-link to="/" class="navbar-brand">
            <img src="images/logotop.png" alt="image" />
          </router-link>
          <button
            class="navbar-toggler"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span class="navbar-toggler-icon">
              <!-- <i class="icofont-navigation-menu ico_menu"></i> -->
              <div class="toggle-wrap">
                <span class="toggle-bar"></span>
              </div>
            </span>
          </button>

          <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav ml-auto">
              <!-- secondery menu start -->

              <li class="nav-item">
                <a class="nav-link dark_btn" href="#" @click="loginBtn">{{
                  loginout
                }}</a>
              </li>
            </ul>
          </div>
        </nav>
        <!-- navigation end -->
      </div>
      <!-- container end -->
    </header>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "Header",
  data() {
    return {
      islogin: false,
      loginout: "",
    };
  },

  mounted() {
    const cObj = localStorage.getItem("isLoggedIn");
    this.islogin = JSON.parse(cObj);
    if (this.islogin) {
      this.loginout = "Logout";
    } else {
      this.loginout = "Login";
    }
  },

  methods: {
    ...mapActions(["logout"]),
    async loginBtn() {
      if (this.loginout == "Logout") {
        await this.logout();
        this.loginout = "Login";
      } else {
        window.scroll(0, 0);
        this.$router.push("/user-login");
      }
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>
